import gql from 'graphql-tag';

import { ApolloInjection } from '@zapier/currency/src/types';
import {
  currencyQuery as CurrencyQueryData,
  currencyQuery_currencies,
} from './types/currencyQuery';

export type Currency = Omit<currencyQuery_currencies, '__typename'>;

export const defaultCurrency = {
  icon: 'UnitedStates',
  id: 'USD',
  multiplier: 1,
  name: 'USD',
  symbol: '$',
  zeroDecimal: false,
};

export const currencyQuery = gql`
  query currencyQuery {
    currencies {
      id
      icon
      multiplier
      name
      symbol
      zeroDecimal
    }
  }
`;

export function useCurrencies(props: ApolloInjection) {
  const useQuery = props.useQuery;
  // @ts-ignore - graphql-proxy fails ts without this even though it does not reference this at all 😭
  const queryResults = useQuery<CurrencyQueryData>(currencyQuery);

  return {
    currencies: queryResults?.data?.currencies || [],
    error: queryResults.error
      ? 'There was an issue loading currencies. Please try again'
      : null,
    isLoading: queryResults.loading,
    onSelectCurrency: (currency: Currency) =>
      queryResults.client.writeData({
        data: { selectedCurrency: currency },
      }),
  };
}
